import { Button, TimePicker, Title, Text } from '_/space-management/components';
import { colors } from '_/space-management/constants/theme';
import { useDateContext } from '_/space-management/hooks/DateContext';
import {
  SpaceType,
  getSpaceTypeColor,
} from '_/space-management/services/models/enums/space-type.enum';
import { SpacesModel } from '_/space-management/services/models/spaces.model';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import React, { View } from 'react-native';

import styles from '../styles';

interface IHandleTimePicker {
  space: SpacesModel;
}
const HandleTimePicker: FC<IHandleTimePicker> = ({ space }) => {
  const { t } = useTranslation();
  const { setTimePickerVisible, timePickerVisible, setSelectedEventDate } = useDateContext();
  const isSpaceTypeWork = space.type === SpaceType.WORK;

  useEffect(() => {
    if (space.type === SpaceType.WORK && !space.scheduleEnabled) {
      setTimePickerVisible(true);
    }
  }, [setTimePickerVisible, space.type, space.scheduleEnabled]);

  // When scheduleEnabled is on, the time window is picked on SlotScheduleScreen
  if (space.scheduleEnabled) {
    return null;
  }

  if (isSpaceTypeWork || timePickerVisible) {
    return (
      <>
        <View style={!isSpaceTypeWork && timePickerVisible ? styles.timePickerTitle : {}}>
          <Title title={t('spaceManage.datePickerScreen.schedule')} />
          {!isSpaceTypeWork && (
            <Text onPress={() => setTimePickerVisible(false)} color={colors.red}>
              {t('spaceManage.datePickerScreen.removeSchedule')}
            </Text>
          )}
        </View>
        <TimePicker editable setEventDate={setSelectedEventDate} />
      </>
    );
  }

  return (
    <View style={styles.wrapper}>
      <Button
        rightIcon="plus"
        textColor={getSpaceTypeColor(space.type)}
        onPress={() => setTimePickerVisible(true)}
      >
        {t('spaceManage.datePickerScreen.addSchedule')}
      </Button>
    </View>
  );
};

export default HandleTimePicker;
